import React from 'react';
import { Template } from './TemplateSelector';

// Comprehensive slide template definitions with improved designs
export const slideTemplates = {
  // Title Slide Templates
  titleSlides: {
    'gradient-center': {
      name: 'Gradient Center Title',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full flex flex-col justify-center items-center text-center relative overflow-hidden"
        style={{ background: template.preview.titleSlide.backgroundColor }} data-id="5pjw88r5z" data-path="src/components/ai/SlideTemplates.tsx">

          {/* Decorative background elements */}
          <div className="absolute inset-0" data-id="4e1t0lpg8" data-path="src/components/ai/SlideTemplates.tsx">
            <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full blur-sm" data-id="zfj1fpm5f" data-path="src/components/ai/SlideTemplates.tsx"></div>
            <div className="absolute bottom-20 right-20 w-24 h-24 bg-white/10 rounded-full blur-sm" data-id="ifwyqub02" data-path="src/components/ai/SlideTemplates.tsx"></div>
            <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/5 rounded-full blur-sm" data-id="cwuz4knvg" data-path="src/components/ai/SlideTemplates.tsx"></div>
          </div>
          
          {slide.imageUrl &&
        <div className="absolute inset-0 z-0" data-id="nuzj3e24f" data-path="src/components/ai/SlideTemplates.tsx">
              <img
            src={slide.imageUrl}
            alt={slide.imageAlt || slide.title}
            className="w-full h-full object-cover opacity-20"
            onError={(e) => {e.currentTarget.style.display = 'none';}} data-id="2z3iq8aaf" data-path="src/components/ai/SlideTemplates.tsx" />

              <div className="absolute inset-0 bg-black/30" data-id="xm11ecv8a" data-path="src/components/ai/SlideTemplates.tsx"></div>
            </div>
        }
          
          <div className="relative z-10 p-8 max-w-4xl" data-id="koxwzgokx" data-path="src/components/ai/SlideTemplates.tsx">
            {isEditing ?
          <input
            value={slide.title}
            onChange={(e) => onUpdate?.({ title: e.target.value })}
            className="text-4xl md:text-6xl font-bold mb-6 bg-transparent border-none outline-none text-center w-full"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="fngdmsr97" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <h1
            className="text-4xl md:text-6xl font-bold mb-6 drop-shadow-lg"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="egu1ft8vx" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.title}
              </h1>
          }
            
            {isEditing ?
          <textarea
            value={slide.content}
            onChange={(e) => onUpdate?.({ content: e.target.value })}
            className="text-xl md:text-2xl leading-relaxed bg-transparent border-none outline-none text-center w-full resize-none"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.9
            }}
            rows={3} data-id="og714uwr7" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <div
            className="text-xl md:text-2xl leading-relaxed drop-shadow"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.9
            }} data-id="kjni1hck9" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.content}
              </div>
          }
            
            {/* Accent line */}
            <div
            className="w-24 h-1 mx-auto mt-6 rounded-full"
            style={{ backgroundColor: template.preview.titleSlide.accentColor }} data-id="er3bs45t9" data-path="src/components/ai/SlideTemplates.tsx">
          </div>
          </div>
        </div>

    },

    'minimal-left': {
      name: 'Minimal Left Aligned',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full flex items-center relative overflow-hidden"
        style={{ backgroundColor: template.preview.titleSlide.backgroundColor }} data-id="xyedtpdrw" data-path="src/components/ai/SlideTemplates.tsx">

          <div className="w-1/2 p-12" data-id="w6tjs1zz7" data-path="src/components/ai/SlideTemplates.tsx">
            {isEditing ?
          <input
            value={slide.title}
            onChange={(e) => onUpdate?.({ title: e.target.value })}
            className="text-4xl md:text-5xl font-bold mb-6 bg-transparent border-none outline-none w-full"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="bb2y3iqaq" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <h1
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="m9wr0a19f" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.title}
              </h1>
          }
            
            {isEditing ?
          <textarea
            value={slide.content}
            onChange={(e) => onUpdate?.({ content: e.target.value })}
            className="text-lg leading-relaxed bg-transparent border-none outline-none w-full resize-none"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.8
            }}
            rows={4} data-id="t3zio7qll" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <div
            className="text-lg leading-relaxed"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.8
            }} data-id="ykrwg97mg" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.content}
              </div>
          }
            
            {/* Decorative element */}
            <div
            className="w-16 h-1 mt-8 rounded-full"
            style={{ backgroundColor: template.preview.titleSlide.accentColor }} data-id="fewkdz3sc" data-path="src/components/ai/SlideTemplates.tsx">
          </div>
          </div>
          
          <div className="w-1/2 h-full relative" data-id="dpjn0v6uv" data-path="src/components/ai/SlideTemplates.tsx">
            {slide.imageUrl ?
          <img
            src={slide.imageUrl}
            alt={slide.imageAlt || slide.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.src = `https://source.unsplash.com/800x600/?education,abstract`;
            }} data-id="o7n8u218v" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <div
            className="w-full h-full flex items-center justify-center"
            style={{ backgroundColor: `${template.preview.titleSlide.accentColor}20` }} data-id="cvbqrwawb" data-path="src/components/ai/SlideTemplates.tsx">

                <div
              className="w-32 h-32 rounded-full opacity-20"
              style={{ backgroundColor: template.preview.titleSlide.accentColor }} data-id="q4r7e29pq" data-path="src/components/ai/SlideTemplates.tsx">
            </div>
              </div>
          }
          </div>
        </div>

    },

    'corporate-split': {
      name: 'Corporate Split Layout',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full flex relative overflow-hidden"
        style={{ background: template.preview.titleSlide.backgroundColor }} data-id="y3etcrygm" data-path="src/components/ai/SlideTemplates.tsx">

          {/* Left side - Content */}
          <div className="w-2/3 p-12 flex flex-col justify-center" data-id="b17jm7pz1" data-path="src/components/ai/SlideTemplates.tsx">
            {isEditing ?
          <input
            value={slide.title}
            onChange={(e) => onUpdate?.({ title: e.target.value })}
            className="text-3xl md:text-4xl font-bold mb-4 bg-transparent border-none outline-none w-full"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="yn3ad7h2t" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <h1
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="wpsyajhgq" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.title}
              </h1>
          }
            
            {isEditing ?
          <textarea
            value={slide.content}
            onChange={(e) => onUpdate?.({ content: e.target.value })}
            className="text-lg leading-relaxed bg-transparent border-none outline-none w-full resize-none"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.9
            }}
            rows={3} data-id="hiiwxm9fe" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <div
            className="text-lg leading-relaxed"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.9
            }} data-id="2zt1ooaw4" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.content}
              </div>
          }
          </div>
          
          {/* Right side - Visual element */}
          <div className="w-1/3 relative" data-id="kvd2hiyyt" data-path="src/components/ai/SlideTemplates.tsx">
            <div
            className="absolute inset-0"
            style={{ backgroundColor: template.preview.titleSlide.accentColor }} data-id="dx9qhxaz9" data-path="src/components/ai/SlideTemplates.tsx">

              <div className="h-full flex items-center justify-center" data-id="lm7jm8gfo" data-path="src/components/ai/SlideTemplates.tsx">
                <div className="text-center p-8" data-id="c42wyt0ib" data-path="src/components/ai/SlideTemplates.tsx">
                  <div
                  className="w-24 h-24 mx-auto mb-4 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} data-id="gnb8kromi" data-path="src/components/ai/SlideTemplates.tsx">

                    <div
                    className="w-12 h-12 rounded-full"
                    style={{ backgroundColor: 'rgba(255,255,255,0.8)' }} data-id="pye2y1c9p" data-path="src/components/ai/SlideTemplates.tsx">
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

    }
  },

  // Content Slide Templates
  contentSlides: {
    'two-column': {
      name: 'Two Column Layout',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full p-8"
        style={{ backgroundColor: template.preview.contentSlide.backgroundColor }} data-id="s0tm15ohw" data-path="src/components/ai/SlideTemplates.tsx">

          {isEditing ?
        <input
          value={slide.title}
          onChange={(e) => onUpdate?.({ title: e.target.value })}
          className="text-2xl font-bold mb-6 bg-transparent border-none outline-none w-full"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="fsbdqbvo3" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <h2
          className="text-2xl font-bold mb-6"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="f5ux9589e" data-path="src/components/ai/SlideTemplates.tsx">

              {slide.title}
            </h2>
        }
          
          <div className="grid grid-cols-2 gap-8 h-5/6" data-id="ra70veq8b" data-path="src/components/ai/SlideTemplates.tsx">
            {isEditing ?
          <textarea
            value={slide.content}
            onChange={(e) => onUpdate?.({ content: e.target.value })}
            className="col-span-2 w-full h-full leading-relaxed text-lg bg-transparent border-none outline-none resize-none"
            style={{
              color: template.preview.contentSlide.textColor,
              fontFamily: template.preview.fonts.body
            }}
            placeholder="Enter content. Use '||' to split into two columns." data-id="wxubmrn5z" data-path="src/components/ai/SlideTemplates.tsx" /> :


          (() => {
            const parts = slide.content.split('||');
            return (
              <>
                    <div
                  className="leading-relaxed text-lg space-y-4"
                  style={{
                    color: template.preview.contentSlide.textColor,
                    fontFamily: template.preview.fonts.body
                  }} data-id="nr9qo9eql" data-path="src/components/ai/SlideTemplates.tsx">

                      {(parts[0] || '').split('\n').map((line, i) =>
                  <p key={i} data-id="j3hwhkqik" data-path="src/components/ai/SlideTemplates.tsx">{line}</p>
                  )}
                    </div>
                    <div
                  className="leading-relaxed text-lg space-y-4"
                  style={{
                    color: template.preview.contentSlide.textColor,
                    fontFamily: template.preview.fonts.body
                  }} data-id="6hfqtmhao" data-path="src/components/ai/SlideTemplates.tsx">

                      {(parts[1] || '').split('\n').map((line, i) =>
                  <p key={i} data-id="aar3wz29f" data-path="src/components/ai/SlideTemplates.tsx">{line}</p>
                  )}
                    </div>
                  </>);

          })()
          }
          </div>
        </div>

    },

    'bullet-points': {
      name: 'Bullet Points with Icon',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full p-8"
        style={{ backgroundColor: template.preview.contentSlide.backgroundColor }} data-id="j596ag097" data-path="src/components/ai/SlideTemplates.tsx">

          {isEditing ?
        <input
          value={slide.title}
          onChange={(e) => onUpdate?.({ title: e.target.value })}
          className="text-2xl font-bold mb-6 bg-transparent border-none outline-none w-full"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="mtspx7v3m" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <h2
          className="text-2xl font-bold mb-6"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="m02oqnb7a" data-path="src/components/ai/SlideTemplates.tsx">

              {slide.title}
            </h2>
        }
          
          {isEditing ?
        <textarea
          value={slide.content}
          onChange={(e) => onUpdate?.({ content: e.target.value })}
          className="w-full h-64 bg-transparent border-none outline-none resize-none"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.body
          }}
          placeholder="Enter bullet points, one per line..." data-id="k0sg4xvct" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <ul className="space-y-6 max-w-4xl" data-id="xfo1u321z" data-path="src/components/ai/SlideTemplates.tsx">
              {slide.content.split('\n').filter((line) => line.trim()).map((item, i) =>
          <li key={i} className="flex items-start space-x-4" data-id="me8i3ga2f" data-path="src/components/ai/SlideTemplates.tsx">
                  <div
              className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
              style={{ backgroundColor: template.preview.contentSlide.accentColor }} data-id="c8km864in" data-path="src/components/ai/SlideTemplates.tsx">

                    <div className="w-3 h-3 bg-white rounded-full" data-id="6dg361qga" data-path="src/components/ai/SlideTemplates.tsx"></div>
                  </div>
                  <span
              className="text-lg leading-relaxed"
              style={{
                color: template.preview.contentSlide.textColor,
                fontFamily: template.preview.fonts.body
              }} data-id="t17ocwqwq" data-path="src/components/ai/SlideTemplates.tsx">

                    {item.replace(/^[•-]\s*/, '')}
                  </span>
                </li>
          )}
            </ul>
        }
        </div>

    },

    'image-content': {
      name: 'Image with Content',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full flex"
        style={{ backgroundColor: template.preview.contentSlide.backgroundColor }} data-id="14663ji38" data-path="src/components/ai/SlideTemplates.tsx">

          {slide.imageUrl &&
        <div className="w-1/2 relative" data-id="yfkccsj5u" data-path="src/components/ai/SlideTemplates.tsx">
              <img
            src={slide.imageUrl}
            alt={slide.imageAlt || slide.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.src = `https://source.unsplash.com/600x400/?${slide.title || 'education'}`;
            }} data-id="9yx06ihgm" data-path="src/components/ai/SlideTemplates.tsx" />

              <div className="absolute inset-0 bg-black/10" data-id="b937b1lwj" data-path="src/components/ai/SlideTemplates.tsx"></div>
            </div>
        }
          
          <div className="w-1/2 p-8 flex flex-col justify-center" data-id="86eirthj1" data-path="src/components/ai/SlideTemplates.tsx">
            {isEditing ?
          <input
            value={slide.title}
            onChange={(e) => onUpdate?.({ title: e.target.value })}
            className="text-2xl font-bold mb-4 bg-transparent border-none outline-none"
            style={{
              color: template.preview.contentSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="kye7ip8tl" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <h2
            className="text-2xl font-bold mb-4"
            style={{
              color: template.preview.contentSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="sskb1wxul" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.title}
              </h2>
          }
            
            {isEditing ?
          <textarea
            value={slide.content}
            onChange={(e) => onUpdate?.({ content: e.target.value })}
            className="leading-relaxed text-lg bg-transparent border-none outline-none resize-none flex-1"
            style={{
              color: template.preview.contentSlide.textColor,
              fontFamily: template.preview.fonts.body
            }} data-id="k6ouzp84i" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <div
            className="leading-relaxed text-lg space-y-4"
            style={{
              color: template.preview.contentSlide.textColor,
              fontFamily: template.preview.fonts.body
            }} data-id="oa9dpvtwv" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.content.split('\n').map((line, i) =>
            <p key={i} data-id="itv7dy8i6" data-path="src/components/ai/SlideTemplates.tsx">{line}</p>
            )}
              </div>
          }
          </div>
        </div>

    },

    'centered-content': {
      name: 'Centered Content',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full flex flex-col justify-center items-center text-center p-12"
        style={{ backgroundColor: template.preview.contentSlide.backgroundColor }} data-id="7u38d27nr" data-path="src/components/ai/SlideTemplates.tsx">

          {isEditing ?
        <input
          value={slide.title}
          onChange={(e) => onUpdate?.({ title: e.target.value })}
          className="text-3xl font-bold mb-8 bg-transparent border-none outline-none text-center"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="l04b9svjh" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <h2
          className="text-3xl font-bold mb-8"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="i76tc46vh" data-path="src/components/ai/SlideTemplates.tsx">

              {slide.title}
            </h2>
        }
          
          {isEditing ?
        <textarea
          value={slide.content}
          onChange={(e) => onUpdate?.({ content: e.target.value })}
          className="text-xl leading-relaxed bg-transparent border-none outline-none text-center resize-none max-w-4xl"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.body
          }}
          rows={6} data-id="bbxfc190f" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <div
          className="text-xl leading-relaxed max-w-4xl"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.body
          }} data-id="yqfxu6a5d" data-path="src/components/ai/SlideTemplates.tsx">

              {slide.content.split('\n').map((line, i) =>
          <p key={i} className="mb-4" data-id="hgpq6jey4" data-path="src/components/ai/SlideTemplates.tsx">{line}</p>
          )}
            </div>
        }
          
          {/* Decorative element */}
          <div
          className="w-24 h-1 mt-8 rounded-full"
          style={{ backgroundColor: template.preview.contentSlide.accentColor }} data-id="0itp81y6i" data-path="src/components/ai/SlideTemplates.tsx">
        </div>
        </div>

    }
  },

  // Special slide types
  specialSlides: {
    'quote-large': {
      name: 'Large Quote',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full flex flex-col justify-center items-center text-center p-12 relative"
        style={{ backgroundColor: template.preview.contentSlide.backgroundColor }} data-id="jwzyg2wl1" data-path="src/components/ai/SlideTemplates.tsx">

          {/* Quote icon */}
          <div
          className="text-8xl opacity-10 absolute top-16 left-1/2 transform -translate-x-1/2"
          style={{ color: template.preview.contentSlide.accentColor }} data-id="s42y8vtc4" data-path="src/components/ai/SlideTemplates.tsx">

            "
          </div>
          
          {isEditing ?
        <textarea
          value={slide.content}
          onChange={(e) => onUpdate?.({ content: e.target.value })}
          className="text-2xl md:text-3xl font-medium italic mb-8 leading-relaxed bg-transparent border-none outline-none text-center w-full resize-none"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }}
          rows={4} data-id="4wvqfn64g" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <blockquote
          className="text-2xl md:text-3xl font-medium italic mb-8 leading-relaxed max-w-4xl relative z-10"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="xydz7rgfh" data-path="src/components/ai/SlideTemplates.tsx">

              "{slide.content}"
            </blockquote>
        }
          
          {isEditing ?
        <input
          value={slide.title}
          onChange={(e) => onUpdate?.({ title: e.target.value })}
          className="text-lg bg-transparent border-none outline-none text-center"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.body,
            opacity: 0.8
          }} data-id="c1gbp21b1" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <cite
          className="text-lg relative z-10"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.body,
            opacity: 0.8
          }} data-id="n363y0oiz" data-path="src/components/ai/SlideTemplates.tsx">

              — {slide.title}
            </cite>
        }
        </div>

    },

    'comparison-vs': {
      name: 'Comparison (Versus)',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full p-8"
        style={{ backgroundColor: template.preview.contentSlide.backgroundColor }} data-id="40dv1c11l" data-path="src/components/ai/SlideTemplates.tsx">

          {isEditing ?
        <input
          value={slide.title}
          onChange={(e) => onUpdate?.({ title: e.target.value })}
          className="text-2xl font-bold text-center mb-8 bg-transparent border-none outline-none w-full"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="345qvsqj8" data-path="src/components/ai/SlideTemplates.tsx" /> :


        <h2
          className="text-2xl font-bold text-center mb-8"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.heading
          }} data-id="84m7ytew2" data-path="src/components/ai/SlideTemplates.tsx">

              {slide.title}
            </h2>
        }
          
          {isEditing ?
        <textarea
          value={slide.content}
          onChange={(e) => onUpdate?.({ content: e.target.value })}
          className="w-full h-64 bg-transparent border-none outline-none resize-none"
          style={{
            color: template.preview.contentSlide.textColor,
            fontFamily: template.preview.fonts.body
          }}
          placeholder="Separate comparison sections with '||'" data-id="9o3s49v5f" data-path="src/components/ai/SlideTemplates.tsx" /> :


        (() => {
          const parts = slide.content.split('||');
          return (
            <div className="grid grid-cols-3 gap-8 h-4/5" data-id="h0uyu6fzc" data-path="src/components/ai/SlideTemplates.tsx">
                  <div
                className="p-6 rounded-lg border-l-4 h-fit"
                style={{
                  backgroundColor: `${template.preview.contentSlide.accentColor}10`,
                  borderLeftColor: template.preview.contentSlide.accentColor
                }} data-id="1z9x852db" data-path="src/components/ai/SlideTemplates.tsx">

                    <div
                  className="leading-relaxed"
                  style={{
                    color: template.preview.contentSlide.textColor,
                    fontFamily: template.preview.fonts.body
                  }} data-id="nkqldzlb4" data-path="src/components/ai/SlideTemplates.tsx">

                      {(parts[0] || '').split('\n').map((line, i) =>
                  <p key={i} className="mb-2" data-id="0jz34p4vk" data-path="src/components/ai/SlideTemplates.tsx">{line}</p>
                  )}
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-center" data-id="0ruhmpw3i" data-path="src/components/ai/SlideTemplates.tsx">
                    <div
                  className="w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold text-white"
                  style={{ backgroundColor: template.preview.contentSlide.accentColor }} data-id="2bdi378tm" data-path="src/components/ai/SlideTemplates.tsx">

                      VS
                    </div>
                  </div>
                  
                  <div
                className="p-6 rounded-lg border-l-4 h-fit"
                style={{
                  backgroundColor: `${template.preview.contentSlide.accentColor}20`,
                  borderLeftColor: template.preview.contentSlide.accentColor
                }} data-id="ro8z0bymt" data-path="src/components/ai/SlideTemplates.tsx">

                    <div
                  className="leading-relaxed"
                  style={{
                    color: template.preview.contentSlide.textColor,
                    fontFamily: template.preview.fonts.body
                  }} data-id="sew60lftn" data-path="src/components/ai/SlideTemplates.tsx">

                      {(parts[1] || '').split('\n').map((line, i) =>
                  <p key={i} className="mb-2" data-id="2x26sgq1x" data-path="src/components/ai/SlideTemplates.tsx">{line}</p>
                  )}
                    </div>
                  </div>
                </div>);

        })()
        }
        </div>

    },

    'conclusion-thank-you': {
      name: 'Thank You Conclusion',
      component: ({ slide, template, isEditing, onUpdate }: any) =>
      <div
        className="h-full flex flex-col justify-center items-center text-center p-12 relative"
        style={{ background: template.preview.titleSlide.backgroundColor }} data-id="w53p0jxbb" data-path="src/components/ai/SlideTemplates.tsx">

          {/* Decorative elements */}
          <div className="absolute inset-0" data-id="39mtxhcpz" data-path="src/components/ai/SlideTemplates.tsx">
            <div className="absolute top-20 left-20 w-24 h-24 bg-white/10 rounded-full blur-sm" data-id="ipok16ucc" data-path="src/components/ai/SlideTemplates.tsx"></div>
            <div className="absolute bottom-20 right-20 w-32 h-32 bg-white/10 rounded-full blur-sm" data-id="mjz4xeb95" data-path="src/components/ai/SlideTemplates.tsx"></div>
            <div className="absolute top-1/3 right-1/4 w-16 h-16 bg-white/5 rounded-full blur-sm" data-id="qrxnj5kh6" data-path="src/components/ai/SlideTemplates.tsx"></div>
          </div>
          
          <div className="relative z-10" data-id="0ocmtcpwa" data-path="src/components/ai/SlideTemplates.tsx">
            {isEditing ?
          <input
            value={slide.title}
            onChange={(e) => onUpdate?.({ title: e.target.value })}
            className="text-4xl font-bold mb-8 bg-transparent border-none outline-none text-center"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="00ta4ujnn" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <h2
            className="text-4xl font-bold mb-8"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.heading
            }} data-id="a9zvp1fn3" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.title}
              </h2>
          }
            
            {isEditing ?
          <textarea
            value={slide.content}
            onChange={(e) => onUpdate?.({ content: e.target.value })}
            className="text-xl leading-relaxed mb-8 bg-transparent border-none outline-none text-center resize-none"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.9
            }}
            rows={4} data-id="omh15uwrk" data-path="src/components/ai/SlideTemplates.tsx" /> :


          <div
            className="text-xl leading-relaxed mb-8 max-w-3xl"
            style={{
              color: template.preview.titleSlide.textColor,
              fontFamily: template.preview.fonts.body,
              opacity: 0.9
            }} data-id="dmbjmcubi" data-path="src/components/ai/SlideTemplates.tsx">

                {slide.content.split('\n').map((line, i) =>
            <p key={i} className="mb-4" data-id="9qx3uv9mr" data-path="src/components/ai/SlideTemplates.tsx">{line}</p>
            )}
              </div>
          }
            
            <div
            className="text-3xl font-bold"
            style={{ color: template.preview.titleSlide.accentColor }} data-id="k8axt97vh" data-path="src/components/ai/SlideTemplates.tsx">

              Thank You!
            </div>
            
            {/* Decorative line */}
            <div
            className="w-32 h-1 mx-auto mt-6 rounded-full"
            style={{ backgroundColor: template.preview.titleSlide.accentColor }} data-id="973exlp8i" data-path="src/components/ai/SlideTemplates.tsx">
          </div>
          </div>
        </div>

    }
  }
};

// Template layout options (like PowerPoint's layout selector)
export const layoutOptions = [
{
  id: 'title-slide',
  name: 'Title Slide',
  description: 'Main title with subtitle',
  category: 'Title',
  icon: '🎯',
  templates: ['gradient-center', 'minimal-left', 'corporate-split']
},
{
  id: 'content-bullets',
  name: 'Content with Bullets',
  description: 'Title and bullet points',
  category: 'Content',
  icon: '📝',
  templates: ['bullet-points']
},
{
  id: 'two-content',
  name: 'Two Content',
  description: 'Two column layout',
  category: 'Content',
  icon: '📋',
  templates: ['two-column']
},
{
  id: 'content-image',
  name: 'Content with Picture',
  description: 'Text content with image',
  category: 'Content',
  icon: '🖼️',
  templates: ['image-content']
},
{
  id: 'centered',
  name: 'Centered Content',
  description: 'Centered text layout',
  category: 'Content',
  icon: '🎪',
  templates: ['centered-content']
},
{
  id: 'quote',
  name: 'Quote',
  description: 'Large quote display',
  category: 'Special',
  icon: '💬',
  templates: ['quote-large']
},
{
  id: 'comparison',
  name: 'Comparison',
  description: 'Side-by-side comparison',
  category: 'Special',
  icon: '⚖️',
  templates: ['comparison-vs']
},
{
  id: 'conclusion',
  name: 'Conclusion',
  description: 'Thank you slide',
  category: 'Ending',
  icon: '🎉',
  templates: ['conclusion-thank-you']
}];


export default slideTemplates;